import React from 'react'

export default function UniversityAnthem() {
    return (
        <div>UniversityAnthem</div>
    )
}
